import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getBasicPropertydetails, PropertyLogoutuser } from "../../Services/Service";
import "../../../AdminWorkspaceTheme.css";

const Hearder = () => {
  const navigate = useNavigate();
  const [PropertyName, setPropertyName] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.body.classList.add("bon-admin-workspace");
    return () => document.body.classList.remove("bon-admin-workspace");
  }, []);

  useEffect(() => {
    const FetchPropeoryName = async () => {
      try {
        const result = await getBasicPropertydetails();
        if (result && result.length > 0) {
          setPropertyName(result[0]);
        }
      }
      catch (error) {
        console.log("error fetch Propeorty Name", error);
      }
    }
    FetchPropeoryName();
  }, []);


  const handleLogout = async () => {
    setLoading(true);
    try {
      const result = await PropertyLogoutuser();

      if (result && result.includes("logged out")) {
        localStorage.clear();
        navigate("/");
      } else {
        console.log("Logout failed:", result);
      }
    } catch (error) {
      console.log("logout error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <FullScreenLoader />
      )}

      <div className="main-header">
        <div className="main-header-logo">
          {/* Logo Header */}
          <div className="logo-header" data-background-color="dark">
            <div className="logo">
              <img
                style={{ width: "73px", height: "auto" }}
                src="../assets/img/BookOnNile Logo.svg"
                alt="/"
                className="navbar-brand bg-white p-2"
              />
            </div>
            <div className="nav-toggle">
              <button className="btn btn-toggle toggle-sidebar">
                <i className="gg-menu-right" />
              </button>
              <button className="btn btn-toggle sidenav-toggler">
                <i className="gg-menu-left" />
              </button>
            </div>
            <button className="topbar-toggler more">
              <i className="gg-more-vertical-alt" />
            </button>
          </div>
          {/* End Logo Header */}
        </div>
        {/* Navbar Header */}
        <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom">
          <div className="container-fluid">
           <h3 className="fw-bold">BookonNile</h3>
            <ul className="navbar-nav topbar-nav ms-md-auto align-items-center">

              <li className="nav-item topbar-icon dropdown hidden-caret d-flex d-lg-none">
                <a
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                  href="/"
                  role="button"
                  aria-expanded="false"
                  aria-haspopup="true"
                >
                  <i className="fa fa-search" />
                </a>
                <ul className="dropdown-menu dropdown-search animated fadeIn">
                  <form className="navbar-left navbar-form nav-search">
                    <div className="input-group">
                      <input
                        type="text"
                        placeholder="Search ..."
                        className="form-control"
                      />
                    </div>
                  </form>
                </ul>
              </li>

              <li className="nav-item topbar-user dropdown hidden-caret">
                <a
                  className="dropdown-toggle profile-pic"
                  data-bs-toggle="dropdown"
                  href="/"
                  aria-expanded="false"
                >

                  {PropertyName?.PropertyLogoURL && (
                    <img
                      src={PropertyName?.PropertyLogoURL}
                      alt="Property Logo"
                      className="avatar-img rounded-circle"
                      style={{ width: "43px" }}
                    />
                  )}


                  <span className="profile-username">

                    <span className="fw-bold mx-1">{PropertyName?.PropertyName}</span>
                    <i className="fas fa-chevron-down"></i>
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-user animated fadeIn">
                  <div className="dropdown-user-scroll scrollbar-outer">
                    <li>
                      {/* <div className="dropdown-divider" /> */}
                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </li>
                  </div>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        {/* End Navbar */}
      </div>
    </>

  );
};

export default Hearder;
